import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { setBreadcrumbItems } from "../../store/actions";

const API = process.env.REACT_APP_API;

const MetodosPago = (props) => {
  document.title = "Metodos de Pago | Atletico Minero - Ges Sindical";

  const breadcrumbItems = [
    { title: "Configuración", link: "#" },
    { title: "Metodos de Pago", link: "#" },
  ];

  const [metodos, setMetodos] = useState([]);
  const [nuevoNombre, setNuevoNombre] = useState('');
  const [loading, setLoading] = useState(true);

  // Cargar métodos de pago
  const cargarMetodos = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/payment-methods`);
      const data = await res.json();
      setMetodos(data);
    } catch (error) {
      Swal.fire('Error', 'No se pudieron cargar los métodos de pago', 'error');
    }
    setLoading(false);
  };

  useEffect(() => {
    props.setBreadcrumbItems('Metodos de Pago', breadcrumbItems);
    cargarMetodos();
    // eslint-disable-next-line
  }, []);

  // Crear método de pago
  const handleCrear = async (e) => {
    e.preventDefault();
    if (!nuevoNombre.trim()) {
      Swal.fire('Atención', 'Ingrese un nombre', 'warning');
      return;
    }
    try {
      const res = await fetch(`${API}/api/payment-methods`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: nuevoNombre.trim() })
      });
      if (res.ok) {
        setNuevoNombre('');
        Swal.fire('¡Listo!', 'Método creado', 'success');
        cargarMetodos();
      } else {
        const data = await res.json();
        Swal.fire('Error', data.error || 'No se pudo crear', 'error');
      }
    } catch {
      Swal.fire('Error', 'No se pudo crear el método', 'error');
    }
  };

  // Eliminar método de pago
  const handleEliminar = async (id) => {
    const confirm = await Swal.fire({
      title: '¿Eliminar método?',
      text: "Esta acción no se puede deshacer.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });
    if (!confirm.isConfirmed) return;
    try {
      const res = await fetch(`${API}/api/payment-methods/${id}`, {
        method: 'DELETE'
      });
      if (res.ok) {
        Swal.fire('Eliminado', 'Método eliminado', 'success');
        cargarMetodos();
      } else {
        Swal.fire('Error', 'No se pudo eliminar', 'error');
      }
    } catch {
      Swal.fire('Error', 'No se pudo eliminar', 'error');
    }
  };

  // Activar/Desactivar método de pago
  const handleToggleEstado = async (id, actual) => {
    try {
      const res = await fetch(`${API}/api/payment-methods/${id}/status`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ isActive: !actual })
      });
      if (res.ok) {
        cargarMetodos();
      } else {
        Swal.fire('Error', 'No se pudo actualizar el estado', 'error');
      }
    } catch {
      Swal.fire('Error', 'No se pudo actualizar el estado', 'error');
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Métodos de Pago</h2>

      {/* Formulario alta */}
      <form className="mb-4" onSubmit={handleCrear} autoComplete="off">
        <div className="row align-items-end">
          <div className="col-md-6">
            <label>Nuevo método de pago:</label>
            <input
              type="text"
              className="form-control"
              value={nuevoNombre}
              onChange={e => setNuevoNombre(e.target.value)}
              placeholder="Ej: Transferencia, Efectivo, Mercado Pago..."
              maxLength={50}
            />
          </div>
          <div className="col-md-2">
            <button className="btn btn-primary w-100" type="submit">Agregar</button>
          </div>
        </div>
      </form>

      {/* Listado */}
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Estado</th>
              <th style={{width: 180}}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {metodos.length === 0 && (
              <tr>
                <td colSpan={3} className="text-center">No hay métodos cargados.</td>
              </tr>
            )}
            {metodos.map(metodo => (
              <tr key={metodo._id}>
                <td>{metodo.name}</td>
                <td>
                  <span className={`badge ${metodo.isActive ? "bg-success" : "bg-danger"}`}>
                    {metodo.isActive ? "Activo" : "Inactivo"}
                  </span>
                </td>
                <td>
                  <button
                    className={`btn btn-sm ${metodo.isActive ? "btn-warning" : "btn-success"} me-2`}
                    onClick={() => handleToggleEstado(metodo._id, metodo.isActive)}
                  >
                    {metodo.isActive ? "Desactivar" : "Activar"}
                  </button>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleEliminar(metodo._id)}
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(MetodosPago);
